import React from "react";
import environment from "environment";

export const DevOnly: React.FC = ({ children }) => {
    return <React.Fragment>{environment.isInDevelopmentMode() && children}</React.Fragment>;
};

export default DevOnly;
